import { Environment } from "./environment.model"

/**
 * copy/pasted from firebase project settings
 */
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDlduQbOCvZrE0IShjr7RJFN5ReaD9QeMQ",
  appId: "1:191423426196:web:979b3ed969cff1c0cb4e81",
  authDomain: "redline-01.firebaseapp.com",
  measurementId: "G-NYBRWZ4LZH",
  messagingSenderId: "191423426196",
  projectId: "redline-01",
  storageBucket: "redline-01.appspot.com",
}

export const environment: Environment = {
  production: false,
  baseUrl: "https://redline-01.web.app",
  firebaseConfig,
  mapOptionsMapId: "2d309616cc8fe83ca11e89dd",
}
